import styled, {css} from "styled-components";

const TsrWithBalanceBtnContainerBox = styled.div<{isInGame: boolean}>`
    display: flex;
    width: 100%;
    justify-content: center;
    
    @media ${({theme}) => theme.mediaQuery.portrait} {
        flex-direction: column;
    }
    
    ${props => !props.isInGame && css`
        width: 60%;    
    `}
`;

export default TsrWithBalanceBtnContainerBox;